module.exports = __webpack_public_path__ + "img/charge-next-page.6e51b39d.png";